import script from "./service-expired.vue?vue&type=script&lang=ts&setup=true"
export * from "./service-expired.vue?vue&type=script&lang=ts&setup=true"

import "./service-expired.vue?vue&type=style&index=0&id=f507ec98&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f507ec98"]])

export default __exports__